var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 73,
    viewBox: "0 0 64 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 73,
    fill: "#3678f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.58,15.126A15.09,15.09,0,1,1,19.478,0a15.117,15.117,0,0,1,15.1,15.126",
    transform: "translate(12.585 -0.001)",
    fill: "#3678f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.938,44.335c-.054-6.278.3-7.254-.27-13.907-.459-5.322-4.208-9.228-10.095-13.083C47.91,13.633,40.251,9.9,31.685,9.987c-8.96.085-16.792,4.072-22.39,7.993C3.968,21.719.679,25.276.4,30.238c-.347,6.119-.344,7.737-.4,14.1Z",
    transform: "translate(0 28.664)",
    fill: "#3678f7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.716cfaf81de3aba18408bd4da26fc203.svg";
export { ForwardRef as ReactComponent };